import { createContext } from 'react';
import type { NotificationFilter, NotificationItem } from './types';

export interface NotificationsContextValue {
  unreadCount: number;
  hasCriticalUnread: boolean;
  latest: NotificationItem[];
  latestFilter: NotificationFilter;
  latestLoading: boolean;
  latestLoaded: boolean;
  version: number;
  refreshCount: () => Promise<void>;
  loadLatest: (filter?: NotificationFilter) => Promise<void>;
  setLatestOpen: (open: boolean) => void;
  markRead: (publicId: string) => Promise<void>;
  markUnread: (publicId: string) => Promise<void>;
  markAllRead: () => Promise<void>;
  archive: (publicId: string) => Promise<void>;
}

export const inertNotificationsValue: NotificationsContextValue = {
  unreadCount: 0,
  hasCriticalUnread: false,
  latest: [],
  latestFilter: 'all',
  latestLoading: false,
  latestLoaded: false,
  version: 0,
  refreshCount: async () => undefined,
  loadLatest: async () => undefined,
  setLatestOpen: () => undefined,
  markRead: async () => undefined,
  markUnread: async () => undefined,
  markAllRead: async () => undefined,
  archive: async () => undefined,
};

export const NotificationsContext = createContext<NotificationsContextValue | null>(null);
